// extracted by mini-css-extract-plugin
module.exports = {"section":"index-module--section--2nAm5","home":"index-module--home--UKgeX","video":"index-module--video--pfXPH"};